export { getSocialHandles } from "./getSocialHandles.mjs";
export { getUrl } from "./getUrl.mjs";
export function getMailtoHref(email) {
  return "mailto:".concat(email);
}
export function getTelHref(phone) {
  return "tel:".concat(phone);
}